import callCmAPI from 'services/helpers/call-cm-api'
import { UserSettingsTableNameEnum } from 'types'

/******************
 * Fetch from API *
 ******************/

type SettingsStructure = {
  keys: string[]
  tableName: UserSettingsTableNameEnum
}

type AddUserSetting = {
  tableName: UserSettingsTableNameEnum
  key: string
  visibility?: boolean
}

export const addUserSetting = ({
  tableName,
  key,
  visibility = false,
}: AddUserSetting): Promise<SettingsStructure[]> =>
  callCmAPI('/user-settings/structure', {
    method: 'put',
    data: {
      tableName,
      newField: {
        key,
        visible: visibility,
      },
    },
  })
    .then((res) => Promise.resolve(res.data.data)) // :)
    .catch((err) => {
      return Promise.reject(err.response.data.error)
    })
